import React from "react";
import { Layout } from "Components/Layout/Layout";

export const Home: React.FC = () => {
  return <Layout></Layout>;
};
